import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetActiveSequenceMetadataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetActiveSequenceMetadataQuery = { __typename?: 'Query', activeProject?: { __typename?: 'PremiereProject', id?: string | null, activeSequence?: { __typename?: 'PremiereSequence', id?: string | null, name?: string | null, end?: number | null, inPoint?: number | null, outPoint?: number | null, start?: number | null, metadata?: Array<{ __typename?: 'SequenceExportsXMPMetadata', exportedAt: number, assetId: string, versionId?: string | null, shareId?: string | null, projectId: string, accountId: string, sequenceId?: string | null, sequenceIn?: number | null, sequenceOut?: number | null } | { __typename?: 'V3PanelExportsXMPMetadata' } | { __typename?: 'V4CommentsPanelExportsXMPMetadata', exportedAt: number, shareId?: string | null } | null> | null } | null } | null };


export const GetActiveSequenceMetadata = /*#__PURE__*/ gql`
    query GetActiveSequenceMetadata {
  activeProject {
    id
    activeSequence {
      id
      name
      end
      inPoint
      outPoint
      start
      metadata {
        ... on SequenceExportsXMPMetadata {
          exportedAt
          assetId
          versionId
          shareId
          projectId
          accountId
          sequenceId
          sequenceIn
          sequenceOut
        }
        ... on V4CommentsPanelExportsXMPMetadata {
          exportedAt
          shareId
        }
      }
    }
  }
}
    ` as unknown as DocumentNode<GetActiveSequenceMetadataQuery, GetActiveSequenceMetadataQueryVariables>;

          

          export const useGetActiveSequenceMetadataQuery = (options?:QueryHookOptions<GetActiveSequenceMetadataQuery, GetActiveSequenceMetadataQueryVariables>) => useQuery(GetActiveSequenceMetadata, options);

          

          export type GetActiveSequenceMetadataQueryOptions = QueryHookOptions<GetActiveSequenceMetadataQuery, GetActiveSequenceMetadataQueryVariables>;

          

          export const useGetActiveSequenceMetadataLazyQuery = (options?:LazyQueryHookOptions<GetActiveSequenceMetadataQuery, GetActiveSequenceMetadataQueryVariables>) => useLazyQuery(GetActiveSequenceMetadata, options);

          

          export type GetActiveSequenceMetadataQueryResult = ReturnType<typeof useGetActiveSequenceMetadataQuery>;

          
